import API from '../config/API';

const authConfig = (token) => token ? { headers: { Authorization: token } } : {};

const settledData = (result, fallback) => (
  result.status === 'fulfilled' ? result.value.data : fallback
);

export async function fetchSessionDetails(sessionId, token) {
  const id = encodeURIComponent(sessionId);
  const [sessionResult, filesResult, quizzesResult, discussionsResult, reviewsResult, linksResult] =
    await Promise.allSettled([
      API.get(`get_session_byID?sessionId=${id}`),
      API.get(`get_file_path_by_session_id?sess_id=${id}`),
      API.get(`get_quizzes_by_sessionId?sessionId=${id}`),
      API.get(`session/discussion/message?sess_id=${id}`, authConfig(token)),
      API.get(`session/reviews/${id}`, authConfig(token)),
      API.get(`session/links/${id}`, authConfig(token)),
    ]);

  if (sessionResult.status === 'rejected') throw sessionResult.reason;

  const sessionPayload = settledData(sessionResult, {});
  const reviewPayload = settledData(reviewsResult, {});
  const session = sessionPayload.sessionDetails?.[0] || null;

  return {
    session,
    files: settledData(filesResult, {})?.data?.file_path || [],
    quizzes: (settledData(quizzesResult, {})?.Quizzes || []).map((quiz, index) => ({
      ...quiz,
      questionId: quiz.id || index + 1,
      options: (quiz.options || []).map((option, optionIndex) => ({
        ...option,
        id: option.id || optionIndex + 1,
        status: Boolean(option.is_correct),
      })),
    })),
    discussions: settledData(discussionsResult, {})?.data || [],
    reviews: reviewPayload.data || [],
    reviewAverage: Number(reviewPayload.review || 0),
    links: settledData(linksResult, {})?.data || session?.links?.map((link, index) => ({ id: index, link })) || [],
  };
}
